import { combineReducers } from "redux";
import { fulfilmentsConstants } from "../../actions/fulfilments/index";

import { presetsConstants } from "../../actions/fulfilments/presets";

import { customersConstants } from "../../actions/fulfilments/customers";

import { activitiesConstants } from "../../actions/fulfilments/activities";

function isGettingFulfilments(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case fulfilmentsConstants.GET_FULFILMENTS_START:
    return true;
  case fulfilmentsConstants.GET_FULFILMENTS_SUCCESS:
  case fulfilmentsConstants.GET_FULFILMENTS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingFulfilments(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case fulfilmentsConstants.GET_FULFILMENTS_ERROR:
    return error ? error : true;
  case fulfilmentsConstants.GET_FULFILMENTS_START:
  case fulfilmentsConstants.GET_FULFILMENTS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function fulfilments(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case fulfilmentsConstants.GET_FULFILMENTS_SUCCESS:
    return payload;
  case fulfilmentsConstants.GET_FULFILMENTS_ERROR:
    return null;
  case fulfilmentsConstants.CLEAR_FULFILMENTS:
    return null;
  default:
    return defaultState;
  }
}

function isGettingFulfilmentCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_CUSTOMERS_START:
    return true;
  case customersConstants.GET_FULFILMENT_CUSTOMERS_SUCCESS:
  case customersConstants.GET_FULFILMENT_CUSTOMERS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingFulfilmentCustomers(state, { type, error }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_CUSTOMERS_ERROR:
    return error ? error : true;
  case customersConstants.GET_FULFILMENT_CUSTOMERS_START:
  case customersConstants.GET_FULFILMENT_CUSTOMERS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function fulfilmentCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_CUSTOMERS_SUCCESS:
    return payload;
  case customersConstants.GET_FULFILMENT_CUSTOMERS_ERROR:
    return null;
  default:
    return defaultState;
  }
}

function fulfilmentActivities(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS:
    return payload;
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR:
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START:
    return {};
  default:
    return defaultState;
  }
}

function isGettingFulfilmentActivities(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR:
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS:
    return false;
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START:
    return true;
  default:
    return defaultState;
  }
}

function isErrorGettingFulfilmentActivities(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_START:
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_SUCCESS:
    return false;
  case activitiesConstants.GET_FULFILMENT_CUSTOMERS_ACTIVITIES_ERROR:
    return true;
  default:
    return defaultState;
  }
}

function isGettingFulfilmentsPreset(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_SUCCESS:
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_ERROR:
    return false;
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_START:
    return true;
  default:
    return defaultState;
  }
}

function isErrorGettingFulfilmentsPreset(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_START:
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_SUCCESS:
    return false;
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_ERROR:
    return true;
  default:
    return defaultState;
  }
}

function fulfilmentsPreset(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_START:
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_ERROR:
    return [];
  case presetsConstants.GET_BACKOFFICE_FULFILMENTS_SUCCESS:
    return payload;
  default:
    return defaultState;
  }
}

function backofficeCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR:
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START:
    return [];
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS:
    return payload;
  default:
    return defaultState;
  }
}

function isGettingBackofficeCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START:
    return true;
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR:
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingBackofficeCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_START:
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_SUCCESS:
    return false;
  case customersConstants.GET_FULFILMENT_BACKOFFICE_CUSTOMERS_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isClosingFulfilment(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case activitiesConstants.SET_FULFILMENT_CLOSED_START:
    return true;
  case activitiesConstants.SET_FULFILMENT_CLOSED_ERROR:
  case activitiesConstants.SET_FULFILMENT_CLOSED_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isErrorClosingFulfilment(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case activitiesConstants.SET_FULFILMENT_CLOSED_START:
  case activitiesConstants.SET_FULFILMENT_CLOSED_SUCCESS:
    return false;
  case activitiesConstants.SET_FULFILMENT_CLOSED_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function filteredCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? [] : state;
  switch (type) {
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR:
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START:
    return [];
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS:
    return payload;
  default:
    return defaultState;
  }
}

function isGettingFilteredCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START:
    return true;
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR:
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS:
    return false;
  default:
    return defaultState;
  }
}

function isErrorGettingFilteredCustomers(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_START:
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_SUCCESS:
    return false;
  case customersConstants.GET_CUSTOMERS_WITHOUT_FULFILMENTID_LIST_ERROR:
    return false;
  default:
    return defaultState;
  }
}

export const fulfilmentsReducer = combineReducers({
  isGettingFulfilments,
  isErrorGettingFulfilments,
  fulfilments,
  isGettingFulfilmentCustomers,
  isErrorGettingFulfilmentCustomers,
  fulfilmentCustomers,
  isGettingFulfilmentActivities,
  isErrorGettingFulfilmentActivities,
  fulfilmentActivities,
  isGettingFulfilmentsPreset,
  isErrorGettingFulfilmentsPreset,
  fulfilmentsPreset,
  isGettingBackofficeCustomers,
  isErrorGettingBackofficeCustomers,
  backofficeCustomers,
  isClosingFulfilment,
  isErrorClosingFulfilment,
  filteredCustomers,
  isGettingFilteredCustomers,
  isErrorGettingFilteredCustomers
});

export default fulfilmentsReducer;
